import script from "./AutoscalerCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoscalerCard.vue?vue&type=script&setup=true&lang=ts"

import "./AutoscalerCard.vue?vue&type=style&index=0&id=eb111abc&lang=scss&scoped=true"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb111abc"]])

export default __exports__